import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext, useEffect, useRef } from 'react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { useFieldValidator } from '../../../../hooks/use-field-validator';
import { Captcha } from '../../../captcha/captcha';
import { FormContextInstance } from '../../form/types/context';
import { getFormFieldErrorMessage } from '../../form-field-utils';
import { Field } from '../field/field';
import { getFieldProps } from '../utils/get-field-props';
const b = bemClassBuilder('v-captcha-field');
export const CaptchaField = observer(props => {
    const i18n = useI18n();
    const { displayText, validationConfig, validate, onChangeValue, setHelpText, error } = props;
    const errorMessage = getFormFieldErrorMessage(error, displayText, i18n);
    if (validationConfig.required === false) {
        throw new Error('Cannot render CaptchaField component when not required.');
    }
    const { onValueChangedValidation } = useFieldValidator(validate, setHelpText, errorMessage);
    const handleValueChanged = (newValue) => {
        onChangeValue(newValue);
        onValueChangedValidation(newValue, true);
    };
    const fieldProps = getFieldProps(Object.assign(Object.assign({}, props), { b, helpText: errorMessage, showLabel: false }));
    const captchaRef = useRef(null);
    const { submitFailed } = useContext(FormContextInstance);
    useEffect(() => {
        var _a;
        if (submitFailed) {
            (_a = captchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        }
    }, [submitFailed, captchaRef]);
    return (_jsx(Field, Object.assign({}, fieldProps, { children: _jsx(Captcha, Object.assign({}, props, { className: undefined, ref: captchaRef, onValueChanged: handleValueChanged })) })));
});
CaptchaField.displayName = 'CaptchaField';
//# sourceMappingURL=captcha-field.js.map